import { ISP, ShopifyOption } from './types';
import allData from '../data/asn_by_countries.json' assert { type: 'json' };

const asnData: ISP[] = allData as ISP[];

export function getISPsByCountry(country: string): ISP[] {
    return asnData.filter((data) => data.country === country) || [];
}

export function getISPsByName(name: string): ISP[] {
    return asnData.filter((data) => data.name.toLowerCase().includes(name.toLowerCase())) || [];
}

export function getISPsByASN(asn: string): ISP | null {
    return asnData.find((data) => data.asn === asn) || null;
}

export function getShopifyOptions(name: string): ShopifyOption[] {
    const data = asnData.filter((data) => data.name.toLowerCase().includes(name.toLowerCase())) || [];
    console.log('data', data);
    const grouped: Record<string, ShopifyOption> = {};

    data.forEach(({ name, asn, country }) => {
        if (!grouped[country]) {
            grouped[country] = { title: country, options: [] };
        }
        grouped[country].options.push({
            label: name,
            value: asn,
        });
    });

    return Object.values(grouped);
}

export default {
    getShopifyOptions,
    getISPsByCountry,
    getISPsByName,
    getISPsByASN,
    asnData
};

export { ShopifyOption } from './types';